var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcumbwrapper-container"},[_c('BreadCumb',{attrs:{"name":_vm.name,"back":_vm.back}}),_c(_vm.component,_vm._b({tag:"component",staticStyle:{"padding-top":"75px"},attrs:{"user":_vm.user}},'component',_vm.params,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }